import { SessionState } from './state';

export const mutations = {
  setFilters(state: SessionState, payload) {
    state.filtersMap[payload.name] = payload.value;
  },
  setAdvancedSearchVisible(state: SessionState, payload) {
    state.advancedSearchVisibleMap[payload.name] = payload.value;
  },
  setTableOptions(state: SessionState, payload) {
    state.tableOptionsMap[payload.name] = payload.value;
  },
  setCachedChoice(state: SessionState, payload) {
    state.choiceCache[payload.name] = payload.value;
  },
  setDeviceGroupID(state: SessionState, payload) {
    state.deviceGroupID = payload;
  },
  setStatusID(state: SessionState, payload) {
    state.statusID = payload;
  }
};
